import React from 'react';
import styles from './ArticlesPreview.module.css';
import ReactMarkdown from "react-markdown";

export default function ArticlesPreview({ articles }) {
  return (
    <div className={styles['articles-preview-row']}>
      {articles.map(article => (
        <div key={article.id} className={styles['article-preview']}>
          <a href={`/articles/${article.id}`} className={styles['article-link']}>
            <img src={article.image} alt={article.title} className={styles['article-image']} />
            <div className={styles['article-title']}>{article.title}</div>
          </a>
        </div>
      ))}
    </div>
  );
}
